const test = node => {
  if (node.tagName === "A" && node.getAttribute("target") === null) {
    // Access href ATTRIBUTE to check for same-page link
    if (node.getAttribute("href")[0] === "#") return false;
    // Access href PROPERTY to get resolved link
    let href = node.href;
    try {
      let uri = new URL(href);
      // mailto:, ftp: etc. must not open in new tab or window:
      if (!["http:", "https:"].includes(uri.protocol)) return false;
      return true;
    } catch (e) {
      // If it is not a valid URL, let the browser handle it.
      return false;
    }
  }
  return false;
};

const handler = ev => {
  let node = ev.target;
  if (test(node)) {
    window.open(node.href);
    ev.preventDefault();
  }
};

const intercept = node => node.addEventListener("click", handler);

export { test, intercept };
